<button (click)="toggleNav()" [attr.aria-label]="isNavOpened ? 'Replier le menu.' : 'Déplier le menu.'"
        [class.opened]="isNavOpened"
        data-tfa="pegase-main-menu_toggle-button"
        id="pegase-menu-toggler-button"
        mat-mini-fab>
  <mat-icon data-tfa="icon-toggle-menu">{{ isNavOpened ? 'chevron_left' : 'chevron_right' }}</mat-icon>
</button>
<!-- pas d'`autosize` : la marge du contenu est posée en CSS (cf. menu.component.scss).
     `autosize` re-mesure la largeur du tiroir à chaque cycle de détection de changement,
     ce qui coûte un reflow sans jamais donner la bonne valeur pendant l'animation. -->
<mat-sidenav-container>

  <mat-sidenav #snav [ngClass]="isNavOpened ? 'pegase-nav-opened' : 'pegase-nav-closed'" id="nav" mode="side" opened>
    <div class="logo-head">
      <a [class.pegase-nav-closed]="!isNavOpened" [href]="homeLink()" data-tfa="pegase-main-menu-link_to_home">
        @if (isNavOpened) {
          <img alt="Logo Pégase" data-tfa="pegase-main-menu_pegase-logo"
               src="assets/img/pegase_logo.png">
        }
        @if (!isNavOpened) {
          <img alt="Logo Pégase" data-tfa="pegase-main-menu_pegase-logo"
               src="assets/img/Logo_Pegase_Blanc_mobile.svg">
        }
      </a>
    </div>
    <!-- first slot: nav items -->
    <div class="menu-list">
      <ng-content select="#nav-content"></ng-content>
    </div>
  </mat-sidenav>
  <mat-sidenav-content [ngClass]="{
    'pegase-nav-opened_content' : isNavOpened,
    'pegase-nav-closed_content': !isNavOpened,
    'fixed-menu': fixedMenu()
  }">
    <em #sidenavContent></em>
    <!-- second slot: page content -->
    <ng-content select="#main-content"></ng-content>
  </mat-sidenav-content>
</mat-sidenav-container>
